import Vue from "vue";

if (process.env.NODE_ENV === 'development') {
    Vue.config.productionTip = true;
} else if (process.env.NODE_ENV === 'production') {
    Vue.config.productionTip = false;
}
